<template>
  <div>
    <license-checker-header @search="handleSearch" />
    <template v-if="response">
      <div>
      <license-checker-body
        :is-loading="isLoading"
        :aside-list="asideList"
        :set-selected-id="setSelectedId"
        :selected-id="selectedId"
        :table-data="tableData"
        :line-items-to-modify="lineItemsToModify"
        :grid="grid"
        :fix-issues="fixIssues"
        :fix-issues-button-text="isFixing ? 'Fixing...' : 'Fix all issues'"
        :modal-data="modalData"
        :order-details="orderDetails"
        :initial-order-details="initialOrderDetails"
        :renewal-order-details="renewalOrderDetails"
        :is-api-complete="isApiComplete"
      />
           <license-checker-modal ref="issuesFixed" 
            :data="modalData"
            />
            </div>
    </template>
    
    <template v-else>
      <h5 class="text-center" style="margin-top: 90px;">No records found.</h5>
    </template>
  </div>
</template>

<script>
import moment from 'moment'

import LicenseCheckerHeader from './license-checker-header'
import LicenseCheckerBody from './license-checker-body'
import LicenseCheckerModal from './license-checker-modal'

export default {
  name: 'LicenseChecker',
  components: { LicenseCheckerHeader, LicenseCheckerBody, LicenseCheckerModal },
  data: () => ({
    isLoading: false,
    response: { AssetDetails: [] }, // to avoid reference error.
    selectedId: '',
    sortedIndicesMap: {},
    uniqueIndicesMap: {},
    isFixing: false,
    searchInput: '',
    modalData: [],
    isApiComplete: false,
    modifyAPIUserName: 'la-007'
  }),
  mounted () {
    if (this.$store.getters.authToken !== null && this.$store.getters.authToken !== undefined) {
      this.modifyAPIUserName = this.$store.getters.authToken.userName === null || this.$store.getters.authToken.userName === undefined ? 'la-007' : this.$store.getters.authToken.userName
    }
  },
  computed: {
    asideList () {
      return this.response.AssetDetails.reduce((acc, cur, i) => {
        if (!i || !acc.find(i => i.assetId === cur.AssetId)) {
          acc.push({
            assetId: cur.AssetId,
            faulty: false,
            children: [{
              orderId: cur.OrderId,
              faultyChildren: cur.LineItemsToModify && !!cur.LineItemsToModify.length
            }]
          })
        } else {
          acc.find(i => i.assetId === cur.AssetId)
            .children.push({
              orderId: cur.OrderId,
              faultyChildren: cur.LineItemsToModify && !!cur.LineItemsToModify.length
            })
        }
        return acc
      }, [])
    },
    tableData () {
      const item = this.getSelectedItem()
      if (!item) return undefined
      return {
        lineItems: item.LineItems,
        assetComponentList: item.AssetComponentList
      }
    },
    lineItemsToModify () {
      const item = this.getSelectedItem()
      if (!item) return undefined
      if (!item.LineItemsToModify || !item.LineItemsToModify.length) return {}
      return item.LineItemsToModify.reduce((acc, cur) => {
        if (!acc[cur.ACTIVATION_ID]) {
          acc[cur.ACTIVATION_ID] = cur
        }
        return acc
      }, {})
    },
    grid () {
      const item = this.getSelectedItem()
      let sortedArray
      if (!item) return undefined
      sortedArray = item.LineItems
        .sort((a, b) => moment.utc(a.CREATED_ON).diff(moment.utc(b.CREATED_ON)))
        .map(i => i.ACTIVATION_ID)
      item.RenewalChainDetails = item.RenewalChainDetails || []
      if (
        sortedArray &&
        item.RenewalChainDetails &&
        sortedArray.length !== item.RenewalChainDetails.length
      ) return undefined
      return sortedArray.map((id, i) => [ id, ...item.RenewalChainDetails[i] ])
    },
    existingDetails () {
      return this.response.ExistingDetails
    },
    orderDetails () {
      const { ExistingDetails } = this.response
      if (!ExistingDetails) return []
      if (!ExistingDetails.OrderDetails) return []
      return this.response.ExistingDetails.OrderDetails
    },
    initialOrderDetails () {
      const {ExistingDetails} = this.response
      if (!ExistingDetails) return []
      if (!ExistingDetails.InitialOrderDetails) return []
      return this.response.ExistingDetails.InitialOrderDetails
    },
    renewalOrderDetails () {
      const {ExistingDetails} = this.response
      if (!ExistingDetails) return []
      if (!ExistingDetails.RenewalOrderDetails) return []
      return this.response.ExistingDetails.RenewalOrderDetails
    }
  },
  methods: {
    getSelectedItem () {
      const { selectedId, response } = this
      const [assetId, orderId] = selectedId.split('|')
      if (selectedId === '') {
        return undefined
      }
      return response.AssetDetails.find(a => a.AssetId === assetId && a.OrderId === orderId)
    },
    handleSearch (searchInput, fromSecondCall = false) {
      searchInput = searchInput.trim()
      this.searchInput = searchInput
      if (this.isSerialNumbervalid(searchInput)) {
        this.isLoading = true
        if (!fromSecondCall) this.selectedId = ''
        this.bottle.get(this.UrlBuilder.getLa007SearchUrl(searchInput))
          .then(({ data }) => {
            this.response = data
            this.isApiComplete = true
          })
          .catch(console.error)
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    setSelectedId (assetId, orderId) {
      this.selectedId = `${assetId}|${orderId}`
    },
    isSerialNumbervalid (serialNumber) {
      return /^([0-9a-zA-Z]*-){2,}([0-9a-zA-Z]*)$/ig.test(serialNumber)
    },
    fixIssues () {
      const [assetId, orderId] = this.selectedId.split('|')
      const licenseDetailsToModify = [ ...(this.response.AssetDetails.find((item) => {
        return item.AssetId === assetId && item.OrderId === orderId
      }) || { LineItemsToModify: [] }).LineItemsToModify ]
      const existingDetails = { ...this.existingDetails }
      this.isFixing = true
      this.bottle
      .post(
        this.UrlBuilder.la007ModifyUrl,
        { licenseDetailsToModify, existingDetails, loggedInUserName: this.modifyAPIUserName }
      )
        .then(({ data }) => {
          this.modalData = data.AItemDetails
          this.$nextTick(() => {
            this.$refs.issuesFixed.showModal()
          })
          this.handleSearch(this.searchInput, true)
        })
        .catch(console.error)
        .finally(() => {
          this.isFixing = false
        })
    }
  }
}
</script>

<style>
.card-header{
  padding:.50rem 1.25rem;
}
.table td,.table th{
  padding:0.50rem;
}
.table thead th{
  font-size:13px;
}
table.table td {
  font-size: 0.8rem;
}
/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}
::-webkit-input-placeholder { /* Edge */
  color: white;
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: white;
}

::placeholder {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/license-checker/index.vue